module.exports = __webpack_public_path__ + "static/media/af4.612b2c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/af4.jpg
// module id = 156
// module chunks = 0